import {
	SafeAreaView,
	ScrollView,
	StyleSheet,
	Text,
	TouchableOpacity,
	View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import { ActivityIndicator, useTheme } from "react-native-paper";
import CachedImage from "../../../../components/CachedImage";
import { Ionicons, AntDesign } from "@expo/vector-icons";
import { setSubUser, User } from "../../../../store/slices/authSlice";
import { getUserImageURI } from "../../../../utils/ImageFunctions";
import useApi from "../../../../hooks/useAPI";
import { showMessage } from "react-native-flash-message";
import { ChooseSubUserScreenProps } from "../AuthStack";

const ChooseSubUser = (props: ChooseSubUserScreenProps) => {
	const auth = useAppSelector(s => s.auth);
	const dispatch = useAppDispatch();
	const [loading, setLoading] = useState(true);
	const { colors } = useTheme();
	const api = useApi();

	useEffect(() => {
		if (auth.subUser) {
			props.navigation.navigate("Home");
		} else {
			setLoading(false);
		}
	}, []);

	if (loading) {
		return <ActivityIndicator size="large" />;
	}
	const onChooseSubUser = (user: User) => {
		dispatch(setSubUser(user));
	};

	const goToAddCard = async () => {
		try {
			const { data } = await api.firstAccess.verifyEmailConfirmation();
			console.log({ data });
			props.navigation.navigate("AuthStack", {
				screen: "CreateCard",
			});
		} catch (error) {
			console.log({ error });
			showMessage({
				type: "warning",
				message: "O seu e-mail ainda não foi confirmado!",
				description:
					"Clique nesta mensagem para reenviar o link de confirmação. Caso precise, clique aqui!",
				duration: 10000,
				position: "bottom",
				onPress: () => {
					api.firstAccess.resendEmail();
				},
			});
		}
	};

	return (
		<SafeAreaView style={styles.root}>
			<ScrollView style={styles.container}>
				<Text style={styles.header}>Painel de Alunos</Text>
				<Text style={styles.text}>
					Escolha um beneficiado para acessar a carteirinha de identificação
					ISIC.
				</Text>
				<View style={styles.cardsContainer}>
					{auth.userInfo.aggregate_users.map(user => {
						return (
							<TouchableOpacity
								key={user.id}
								style={styles.card}
								onPress={() => onChooseSubUser(user)}
							>
								<View style={styles.cardLeft}>
									<CachedImage
										cacheKey={user.card.image_id}
										source={{ uri: getUserImageURI(user.card.image_id) }}
										style={styles.userImage}
										resizeMode="contain"
									/>
									<View>
										<Text style={styles.name}>{user.card.name}</Text>
										<Text>{user.card.institution}</Text>
									</View>
								</View>
								<View
									style={[
										styles.cardRight,
										{ backgroundColor: colors.primary },
									]}
								>
									<Ionicons name="chevron-forward" size={40} color="#fff" />
								</View>
							</TouchableOpacity>
						);
					})}
				</View>
				<TouchableOpacity style={styles.card} onPress={goToAddCard}>
					<View style={styles.cardLeft}>
						<View style={[styles.userImage, styles.plusIconContainer]}>
							<AntDesign name="plus" size={24} color="#A3A3A3" />
						</View>
						<View>
							<Text style={styles.name}>Adicionar novo aluno</Text>
						</View>
					</View>
					<View style={[styles.cardRight, { backgroundColor: colors.primary }]}>
						<Ionicons name="chevron-forward" size={40} color="#fff" />
					</View>
				</TouchableOpacity>
			</ScrollView>
		</SafeAreaView>
	);
};

export default ChooseSubUser;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
	},
	container: {
		paddingHorizontal: "5%",
	},
	header: {
		fontWeight: "600",
		fontSize: 32,
		marginTop: 20,
	},
	text: {
		color: "#999999",
		marginVertical: 15,
	},
	cardsContainer: {},
	card: {
		backgroundColor: "#f4f4f4",
		flexDirection: "row",
		alignItems: "center",
		height: 80,
		borderRadius: 21,
		marginBottom: 15,
	},
	cardLeft: {
		flexDirection: "row",
		alignItems: "center",
		flex: 1,
	},
	userImage: {
		width: 40,
		height: 40,
		borderRadius: 20,
		marginRight: 10,
		marginLeft: 16,
	},
	cardRight: {
		height: "100%",
		width: "21%",
		justifyContent: "center",
		alignItems: "center",
		borderBottomRightRadius: 21,
		borderTopRightRadius: 21,
	},
	name: {
		fontSize: 16,
		fontWeight: "600",
		marginBottom: 3,
	},
	plusIconContainer: {
		backgroundColor: "#fff",
		alignItems: "center",
		justifyContent: "center",
	},
});
